import {Pipe, PipeTransform} from '@angular/core';
import {format} from 'date-fns';

@Pipe({
    name: 'fnsDateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  transform(value: Date, ...args: any[]): any {
    if (!value) {
      return '';
    }

    return format(value, args[0]);
  }
}
